export const MTN_HOSTNAME = 'gh-mtn.trace.plus';

/** Penrose subscribe page for MTN Ghana (also returned by the backend as `url` / `subscribeUrl`). */
export const MTN_SUBSCRIBE_URL =
  process.env.GATSBY_MTN_SUBSCRIBE_URL || 'http://traceplus.ghgames.co';

/**
 * Set only when the backend runs with MTN_DB_DISABLED (testing): the login is
 * not a Firebase login, we just keep the mtnToken for refresh/unsubscribe.
 */
export const MTN_TEST_LOGIN_KEY = 'mtn_test_login';

export const isMtnHostname = (): boolean =>
  typeof window !== 'undefined' &&
  window.location.hostname.toLowerCase() === MTN_HOSTNAME;

/**
 * MTN-only site: gh-mtn.trace.plus, or dev override via ?mtnOnly=1 or
 * GATSBY_MTN_ONLY_DOMAIN_TEST=1.
 */
export const isMtnSite = (): boolean => {
  if (typeof window === 'undefined') return false;
  if (isMtnHostname()) return true;
  if (process.env.GATSBY_MTN_ONLY_DOMAIN_TEST === '1') return true;
  try {
    return new URL(window.location.href).searchParams.get('mtnOnly') === '1';
  } catch {
    return false;
  }
};
